import React, { Component } from 'react'
class ProjectLandscapeGifImage extends Component {

  render() {

  	let { gifLandscapeImage, imageContainer, bgcolour } = this.props

    return (
      <section className='project-landscape-gif-image' style={{backgroundColor:bgcolour}}>
        <div className={'project-landscape-gif-image__contained ' + imageContainer}>
          <img className='gif' src={gifLandscapeImage?.sourceUrl} alt='StudioSmall' />
        </div>
      </section>
    )
  }
}

export default ProjectLandscapeGifImage
